/**
 * User: liliana
 * Date: 4/16/15
 * Time: 5:55 PM
 * Copyright 1stdibs.com, Inc. 2013. All Rights Reserved.
 */

'use strict';

var SoaModel               = require('bunsen/models/SoaModel');

/**
 * @class FavoriteParameter
 * @extends SoaModel
 * @constructs FavoriteParameter object
 * @constructor
 */
var FavoriteParameter      = module.exports = SoaModel.extend();

var _                      = require('underscore');
var numberConversions      = require('bunsen/helpers/numberConversions');
var FinancialAmounts       = require('bunsen/models/FinancialAmount');

_.extend(FavoriteParameter.prototype, {

    /**
     * True if parameter values should be pre-processed before display
     * @return {boolean}
     */
    shouldPreProcess : function () {
        return FavoriteParameter.PRE_PROCESS_KEYS.indexOf(this.get('key')) > -1;
    },

    /**
     * Returns array of pre-processed values
     * Current use case is to translate true/false bools to Yes/No
     * @return {string[]}
     */
    preProcessValues : function () {
        var values = this.get('values');
        return _.map(values, function (value) {
            return FavoriteParameter.PRE_PROCESS_DISPLAY_MAP[value] || value;
        });
    },

    /**
     * @return {boolean} True if parameter is for internal use and not display
     */
    isInternal : function () {
        return FavoriteParameter.DISPLAY_MAP[this.get('key')] ? false : true;
    },

    /**
     * @return {boolean} True if key has numerical range value
     */
    hasNumericRange : function () {
        return FavoriteParameter.NUMERIC_RANGE_KEYS.indexOf(this.get('key')) > -1;
    },

    /**
     * Lookup and return display text for key; fallback to key if not in map
     * @returns {string}
     */
    getDisplayKey : function () {
        var key = this.get('key');
        var model;
        // TODO: Rip this logic out after BE adds numerical_length label to tell the difference b/t height and length
        if (key === FavoriteParameter.KEY_HEIGHT) {
            model = this.collection ? this.collection.findWhere({ key : FavoriteParameter.KEY_CATEGORY_L2 }) : null;
            if (model && FavoriteParameter.SHOW_LENGTH_CATEGORIES.indexOf(model.getDisplayValue()) > -1) {
                key = FavoriteParameter.KEY_LENGTH;
            }
        }
        return FavoriteParameter.DISPLAY_MAP[key] || key;
    },

    /**
     * Format and return display value for parameter
     * @returns {string} value
     */
    getDisplayValue : function () {
        var key = this.get('key');
        var values = this.get('values');
        var currency = FinancialAmounts.CURRENCY_USD;
        var amounts = [];
        var model;
        var display;

        // Only pre-process if key is in map
        if (this.shouldPreProcess()) {
            values = this.preProcessValues();
        }

        // Numeric range values are concatenated with appropriate unit and delimited by en dash
        if (this.hasNumericRange()) {
            // Price and currency
            if (key === FavoriteParameter.KEY_PRICE) {

                // Get currency from currency param model in params collection, default to USD
                model = this.collection ? this.collection.findWhere({ key : FavoriteParameter.KEY_CURRENCY }) : null;
                currency = model ? model.getDisplayValue() : currency;

                // Format price
                amounts = _.map(values, function(value) {
                    return numberConversions.intelligentFormat(value, currency);
                });
                // Measurements
            } else {
                amounts = _.map(values, function (value, index) {
                    if (value === '*') {
                        // Min / max are indicated by asterisk, replace depending on index
                        value = index > 0 ? 'Max' : 'Min';
                    } else {
                        // Otherwise, must be number and convert to feet in long form
                        value = numberConversions.convert(value, 'inch', 'feet');
                        value = numberConversions.convert(value, 'feet', 'longForm');
                    }
                    return value;
                });
            }
            display = _.unescape(amounts.join(' &ndash; '));
        } else {

            // All other filters are concatenated with comma e.g. Art-Deco, Contemporary
            display = values.join(', ');
        }
        return display;
    }
});

_.extend(FavoriteParameter, (function () {
    var keys;
    var displays;
    var maps;
    var lists;

    // Parameter Keys
    keys = {
        KEY_QUERY              : 'query',
        KEY_CATEGORY           : 'category',
        KEY_CATEGORY_L2        : 'category_l2',
        KEY_PRICE              : 'price',
        KEY_CURRENCY           : 'currency',
        KEY_PERIOD             : 'period',
        KEY_CREATOR            : 'creator',
        KEY_LOCATION           : 'location',
        KEY_ASSOCIATION        : 'association',
        KEY_COLLECTION         : 'collection',
        KEY_HEIGHT             : 'height',
        KEY_WIDTH              : 'width',
        KEY_LENGTH             : 'length',
        KEY_SECTION_FURNITURE  : 'furniture_section',
        KEY_SECTION_FASHION    : 'fashion_section',
        KEY_SECTION_JEWELRY    : 'jewelry_section',
        KEY_GENDER             : 'gender',
        KEY_ORIGIN             : 'origin',
        KEY_MATERIAL           : 'material',
        KEY_METAL              : 'metal',
        KEY_DEALER             : 'dealer',
        KEY_SHIPPING           : 'shipping',
        KEY_SOLD               : 'sold',
        KEY_STONE              : 'stone',
        KEY_STYLE              : 'style',
        KEY_TECHNIQUE          : 'technique',
        KEY_ITEM_COUNT         : 'item_count',
        KEY_NEW_ITEM_COUNT     : 'new_item_count',
        KEY_COLOR              : 'color'
    };

    // Parameter Display Text
    displays = {
        DISPLAY_QUERY              : 'Search Term',
        DISPLAY_CATEGORY           : 'Category',
        DISPLAY_PRICE              : 'Price',
        DISPLAY_CURRENCY           : 'Currency',
        DISPLAY_PERIOD             : 'Period',
        DISPLAY_CREATOR            : 'Creator',
        DISPLAY_LOCATION           : 'Location',
        DISPLAY_ASSOCIATION        : 'Association',
        DISPLAY_COLLECTION         : 'Collection',
        DISPLAY_HEIGHT             : 'Height',
        DISPLAY_WIDTH              : 'Width',
        DISPLAY_LENGTH             : 'Length',
        DISPLAY_SECTION_FURNITURE  : 'Section',
        DISPLAY_SECTION_FASHION    : 'Section',
        DISPLAY_SECTION_JEWELRY    : 'Section',
        DISPLAY_GENDER             : 'Gender',
        DISPLAY_ORIGIN             : 'Origin',
        DISPLAY_MATERIAL           : 'Material',
        DISPLAY_METAL              : 'Metal',
        DISPLAY_DEALER             : 'Dealer',
        DISPLAY_SHIPPING           : 'Shipping',
        DISPLAY_SOLD               : 'Show Sold',
        DISPLAY_STONE              : 'Stone',
        DISPLAY_STYLE              : 'Style',
        DISPLAY_TECHNIQUE          : 'Technique',
        DISPLAY_NEW_ITEMS          : 'New Items',
        DISPLAY_COLOR              : 'Color'
    };

    // Parameters lists
    lists  = {

        // Keys whose values are numeric ranges
        NUMERIC_RANGE_KEYS : [
            keys.KEY_PRICE,
            keys.KEY_HEIGHT,
            keys.KEY_WIDTH
        ],

        // TODO: Rip this logic out after BE adds numerical_length label to tell the difference b/t height and length
        // Categories that use length instead of height for dimensions
        SHOW_LENGTH_CATEGORIES : [
            'Rugs and Carpets',
            'Rugs'
        ],

        // Keys with values that need to be pre-processed
        PRE_PROCESS_KEYS : [
            keys.KEY_SOLD
        ]
    };

    // Parameters mappings
    maps = {

        // Map key to display text
        DISPLAY_MAP : {
            [keys.KEY_QUERY]              : displays.DISPLAY_QUERY,
            [keys.KEY_CATEGORY]           : displays.DISPLAY_CATEGORY,
            [keys.KEY_PRICE]              : displays.DISPLAY_PRICE,
            [keys.KEY_CURRENCY]           : displays.DISPLAY_CURRENCY,
            [keys.KEY_PERIOD]             : displays.DISPLAY_PERIOD,
            [keys.KEY_CREATOR]            : displays.DISPLAY_CREATOR,
            [keys.KEY_LOCATION]           : displays.DISPLAY_LOCATION,
            [keys.KEY_ASSOCIATION]        : displays.DISPLAY_ASSOCIATION,
            [keys.KEY_COLLECTION]         : displays.DISPLAY_COLLECTION,
            [keys.KEY_HEIGHT]             : displays.DISPLAY_HEIGHT,
            [keys.KEY_WIDTH]              : displays.DISPLAY_WIDTH,
            [keys.KEY_LENGTH]             : displays.DISPLAY_LENGTH,
            [keys.KEY_SECTION_FURNITURE]  : displays.DISPLAY_SECTION_FURNITURE,
            [keys.KEY_SECTION_FASHION]    : displays.DISPLAY_SECTION_FASHION,
            [keys.KEY_SECTION_JEWELRY]    : displays.DISPLAY_SECTION_JEWELRY,
            [keys.KEY_GENDER]             : displays.DISPLAY_GENDER,
            [keys.KEY_ORIGIN]             : displays.DISPLAY_ORIGIN,
            [keys.KEY_MATERIAL]           : displays.DISPLAY_MATERIAL,
            [keys.KEY_METAL]              : displays.DISPLAY_METAL,
            [keys.KEY_DEALER]             : displays.DISPLAY_DEALER,
            [keys.KEY_SHIPPING]           : displays.DISPLAY_SHIPPING,
            [keys.KEY_SOLD]               : displays.DISPLAY_SOLD,
            [keys.KEY_STONE]              : displays.DISPLAY_STONE,
            [keys.KEY_STYLE]              : displays.DISPLAY_STYLE,
            [keys.KEY_TECHNIQUE]          : displays.DISPLAY_TECHNIQUE,
            [keys.KEY_NEW_ITEM_COUNT]     : displays.DISPLAY_NEW_ITEMS,
            [keys.KEY_COLOR]              : displays.DISPLAY_COLOR
        },

        PRE_PROCESS_DISPLAY_MAP : {
            'true'     : 'Yes',
            'false'    : 'No'
        }
    };
    return _.extend(keys, displays, lists, maps);
}()));



// WEBPACK FOOTER //
// ./~/bunsen/models/identity/FavoriteParameter.es.js